// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Container,
//   Paper,
//   Snackbar,
//   Alert as MuiAlert,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   CircularProgress,
// } from '@mui/material';
// import { AttachFile as AttachFileIcon, CloudUpload as CloudUploadIcon } from '@mui/icons-material';
// import { motion } from 'framer-motion';
// import { useAuth } from './auth/AuthContext';
// import api from '../utils/api';

// const classes = [
//   'PP1', 'PP2', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6',
//   'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12',
// ];
// const subjects = [
//   'Mathematics', 'English', 'Kiswahili/KSL', 'Integrated Science', 'Social Studies',
//   'CRE', 'IRE', 'History', 'Geography', 'Business', 'Pretechnical Studies',
//   'Creative Arts and Sports', 'Agriculture and Nutrition',
// ];

// const UploadTeacherResource = () => {
//   const navigate = useNavigate();
//   const { isAdminAuthenticated } = useAuth();
//   const [title, setTitle] = useState('');
//   const [description, setDescription] = useState('');
//   const [selectedClass, setSelectedClass] = useState(classes[0]);
//   const [selectedSubject, setSelectedSubject] = useState(subjects[0]);
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const handleFileChange = (event) => {
//     const selectedFile = event.target.files[0];
//     if (selectedFile) {
//       const allowedTypes = [
//         'application/pdf',
//         'application/msword',
//         'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//         'image/jpeg',
//         'image/png',
//         'image/gif',
//       ];
//       if (!allowedTypes.includes(selectedFile.type)) {
//         setSnackbar({
//           open: true,
//           message: 'Invalid file type. Please select a PDF, DOC, DOCX, or image.',
//           severity: 'error',
//         });
//         return;
//       }
//       setFile({ name: selectedFile.name, file: selectedFile });
//       setErrors({ ...errors, file: '' });
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!title.trim()) newErrors.title = 'Title is required';
//     if (!file) newErrors.file = 'Please select a file';
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleUpload = async () => {
//     if (!isAdminAuthenticated) {
//       setSnackbar({
//         open: true,
//         message: 'Please login as admin first',
//         severity: 'error',
//       });
//       return;
//     }

//     if (!validateForm()) {
//       setSnackbar({
//         open: true,
//         message: 'Please fill in all required fields',
//         severity: 'error',
//       });
//       return;
//     }

//     setLoading(true);
//     const formData = new FormData();
//     formData.append('title', title);
//     formData.append('description', description);
//     formData.append('class', selectedClass);
//     formData.append('subject', selectedSubject);
//     formData.append('file', file.file);

//     try {
//       await api.post('/api/schools/teacher-resources', formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });
//       setSnackbar({
//         open: true,
//         message: 'Resource uploaded successfully!',
//         severity: 'success',
//       });
//       setTimeout(() => navigate(-1), 2000);
//     } catch (error) {
//       console.error('Error uploading resource:', error);
//       setSnackbar({
//         open: true,
//         message: error.response?.data?.message || 'Failed to upload resource. Please try again.',
//         severity: 'error',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   return (
//     <Container maxWidth="sm" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 4, textAlign: 'center' }}>
//           Upload Teacher Resource
//         </Typography>
//         <Paper sx={{ p: 3, bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
//           <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3, delay: 0.1 }}>
//             <TextField
//               fullWidth
//               label="Title *"
//               value={title}
//               onChange={(e) => { setTitle(e.target.value); setErrors({ ...errors, title: '' }); }}
//               error={!!errors.title}
//               helperText={errors.title}
//               sx={{ mb: 2, bgcolor: '#fff' }}
//             />
//           </motion.div>
//           <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3, delay: 0.2 }}>
//             <TextField
//               fullWidth
//               label="Description"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//               multiline
//               rows={4}
//               sx={{ mb: 2, bgcolor: '#fff' }}
//             />
//           </motion.div>
//           <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3, delay: 0.3 }}>
//             <FormControl fullWidth sx={{ mb: 2, bgcolor: '#fff' }}>
//               <InputLabel>Class</InputLabel>
//               <Select value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)} label="Class">
//                 {classes.map((className) => (
//                   <MenuItem key={className} value={className}>{className}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </motion.div>
//           <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3, delay: 0.4 }}>
//             <FormControl fullWidth sx={{ mb: 2, bgcolor: '#fff' }}>
//               <InputLabel>Subject</InputLabel>
//               <Select value={selectedSubject} onChange={(e) => setSelectedSubject(e.target.value)} label="Subject">
//                 {subjects.map((subject) => (
//                   <MenuItem key={subject} value={subject}>{subject}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </motion.div>
//           <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3, delay: 0.5 }}>
//             <Button
//               variant="contained"
//               component="label"
//               startIcon={<AttachFileIcon />}
//               sx={{
//                 bgcolor: '#6200ee',
//                 '&:hover': { bgcolor: '#7f39fb' },
//                 borderRadius: 2,
//                 mb: 2,
//                 py: 1.5,
//                 fontSize: '1rem',
//                 textTransform: 'none',
//               }}
//             >
//               Select File (PDF/DOC/Image)
//               <input type="file" hidden accept=".pdf,.doc,.docx,image/*" onChange={handleFileChange} />
//             </Button>
//             {errors.file && <Typography color="error" variant="caption">{errors.file}</Typography>}
//           </motion.div>
//           {file && (
//             <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3, delay: 0.6 }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#fff', borderRadius: 2, p: 2, mb: 2, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
//                 <AttachFileIcon sx={{ color: '#6200ee', mr: 1 }} />
//                 <Typography variant="body2" sx={{ color: '#2c3e50', flex: 1 }}>{file.name}</Typography>
//               </Box>
//             </motion.div>
//           )}
//           <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3, delay: 0.7 }}>
//             <Button
//               variant="contained"
//               startIcon={loading ? null : <CloudUploadIcon />}
//               onClick={handleUpload}
//               disabled={loading}
//               fullWidth
//               sx={{
//                 bgcolor: '#9C27B0',
//                 '&:hover': { bgcolor: '#aa00cc' },
//                 borderRadius: 2,
//                 py: 1.5,
//                 fontSize: '1.1rem',
//                 fontWeight: 'bold',
//                 mt: 2,
//                 opacity: loading ? 0.6 : 1,
//               }}
//             >
//               {loading ? <CircularProgress size={24} color="inherit" /> : 'Upload Resource'}
//             </Button>
//           </motion.div>
//         </Paper>
//       </motion.div>
//       <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
//         <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
//           {snackbar.message}
//         </MuiAlert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default UploadTeacherResource;


// UploadTeacherResource.js - UPDATED (Simple like notes)
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Paper,
  Snackbar,
  Alert as MuiAlert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import { AttachFile as AttachFileIcon, CloudUpload as CloudUploadIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';
import api from '../utils/api';

const classes = [
  'PP1', 'PP2', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6',
  'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12',
];
const subjects = [
  'Mathematics', 'English', 'Kiswahili/KSL', 'Integrated Science', 'Social Studies',
  'CRE', 'IRE', 'History', 'Geography', 'Business', 'Pretechnical Studies',
  'Creative Arts and Sports', 'Agriculture and Nutrition',
];

const UploadTeacherResource = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    class: classes[0],
    subject: subjects[0],
  });
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/jpeg',
        'image/png',
      ];
      
      if (!allowedTypes.includes(selectedFile.type)) {
        setSnackbar({
          open: true,
          message: 'Invalid file type. Please select PDF, DOC, DOCX, or image files.',
          severity: 'error',
        });
        return;
      }
      
      // Check file size (10MB max - same as notes)
      if (selectedFile.size > 10 * 1024 * 1024) {
        setSnackbar({
          open: true,
          message: 'File too large. Maximum size is 10MB.',
          severity: 'error',
        });
        return;
      }
      
      setFile(selectedFile);
      setErrors(prev => ({ ...prev, file: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title.trim()) newErrors.title = 'Title is required';
    if (!file) newErrors.file = 'Please select a file';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpload = async () => {
    if (!validateForm()) {
      setSnackbar({
        open: true,
        message: 'Please fill in all required fields',
        severity: 'error',
      });
      return;
    }

    setLoading(true);
    
    const uploadFormData = new FormData();
    uploadFormData.append('title', formData.title);
    uploadFormData.append('description', formData.description);
    uploadFormData.append('class', formData.class);
    uploadFormData.append('subject', formData.subject);
    uploadFormData.append('file', file);

    try {
      const response = await api.post('/api/schools/teacher-resources', uploadFormData, {
        headers: { 
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('Upload response:', response.data);

      if (response.data.success) {
        setSnackbar({
          open: true,
          message: 'Resource uploaded successfully!',
          severity: 'success',
        });
        // Reset form
        setFormData({
          title: '',
          description: '',
          class: classes[0],
          subject: subjects[0],
        });
        setFile(null);
        setTimeout(() => navigate(-1), 2000);
      }
    } catch (error) {
      console.error('Error uploading resource:', error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || 'Failed to upload resource. Please try again.',
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 4, textAlign: 'center' }}>
          Upload Teacher Resource
        </Typography>
        
        <Paper sx={{ p: 3, bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
          <TextField
            fullWidth
            label="Title *"
            value={formData.title}
            onChange={(e) => handleInputChange('title', e.target.value)}
            error={!!errors.title}
            helperText={errors.title}
            sx={{ mb: 2 }}
          />
          
          <TextField
            fullWidth
            label="Description"
            value={formData.description}
            onChange={(e) => handleInputChange('description', e.target.value)}
            multiline
            rows={3}
            sx={{ mb: 2 }}
          />
          
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Class *</InputLabel>
            <Select 
              value={formData.class} 
              onChange={(e) => handleInputChange('class', e.target.value)} 
              label="Class *"
            >
              {classes.map((className) => (
                <MenuItem key={className} value={className}>{className}</MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Subject *</InputLabel>
            <Select 
              value={formData.subject} 
              onChange={(e) => handleInputChange('subject', e.target.value)} 
              label="Subject *"
            >
              {subjects.map((subject) => (
                <MenuItem key={subject} value={subject}>{subject}</MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <Button
            variant="outlined"
            component="label"
            startIcon={<AttachFileIcon />}
            sx={{ mb: 2 }}
            fullWidth
          >
            Select File (PDF/DOC/Image) *
            <input 
              type="file" 
              hidden 
              accept=".pdf,.doc,.docx,image/*" 
              onChange={handleFileChange} 
            />
          </Button>
          
          {errors.file && (
            <Typography color="error" variant="caption" sx={{ display: 'block', mb: 2 }}>
              {errors.file}
            </Typography>
          )}
          
          {file && (
            <Box sx={{ display: 'flex', alignItems: 'center', p: 2, bgcolor: '#f5f5f5', borderRadius: 1, mb: 2 }}>
              <AttachFileIcon sx={{ color: '#6200ee', mr: 1 }} />
              <Typography variant="body2" sx={{ flex: 1 }}>
                {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
              </Typography>
            </Box>
          )}
          
          <Button
            variant="contained"
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CloudUploadIcon />}
            onClick={handleUpload}
            disabled={loading}
            fullWidth
            sx={{ py: 1.5 }}
          >
            {loading ? 'Uploading...' : 'Upload Resource'}
          </Button>
        </Paper>
      </motion.div>
      
      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </Container>
  );
};

export default UploadTeacherResource;